import { render, staticRenderFns } from "./IndividualSLP.vue?vue&type=template&id=761b03b2&scoped=true&"
import script from "./IndividualSLP.vue?vue&type=script&lang=ts&"
export * from "./IndividualSLP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761b03b2",
  null
  
)

export default component.exports